import React, { useContext, useEffect } from 'react';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import IconButton from './IconButton';
import IconTemplateList from 'venuescanner-js/react/components/Objects/Icons/IconTemplateList';
import ManageTemplatesModal from './ManageTemplatesModal';
import classes from '../../../../styles.module';
import templateQueries from './queries';

const TemplatesMenuItem = ({ children, style, ...props }) => {
  const styleToApply = style || {};
  if (styleToApply.minHeight) {
    throw new Error(
      'we are overriding min-height here, do not supply from call site',
    );
  }
  styleToApply.minHeight = '40px';
  return (
    <MenuItem {...props} style={styleToApply}>
      {' '}
      {children}
    </MenuItem>
  );
};
const TemplatesPopupMenu = ({ onTemplateSelected, ...props }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [manageTemplatesModalOpen, setManageTemplatesModalOpen] =
    React.useState(false);
  const { isMobileDevice } = useContext(ViewContext);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTemplateSelected = template => {
    if (onTemplateSelected) {
      onTemplateSelected(template);
    }
    handleClose();
  };

  const openManageTemplatesModal = () => {
    setManageTemplatesModalOpen(true);
    handleClose();
  };

  const closeManageTemplatesModal = () => setManageTemplatesModalOpen(false);

  const { data: templates } = templateQueries.all();
  const hasTemplates = Boolean(templates?.length);

  const applyTemplateMenuItems = hasTemplates
    ? // MUI: The Menu component doesn't accept a Fragment as a child.
      [
        <TemplatesMenuItem disabled key='templates-section-header-item'>
          Templates
        </TemplatesMenuItem>,
      ]
        .concat(
          templates.map(template => (
            <TemplatesMenuItem
              onClick={() => handleTemplateSelected(template)}
              title={template.content}
              key={template._id}>
              {template.name}
            </TemplatesMenuItem>
          )),
        )
        .concat([<Divider key='divider-between-templates-and-actions' />])
    : null;
  useEffect(() => {
    if (!hasTemplates) {
      closeManageTemplatesModal();
    }
  });

  return (
    <>
      <ManageTemplatesModal
        open={manageTemplatesModalOpen}
        onClose={closeManageTemplatesModal}
      />
      <IconButton
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        icon={
          <IconTemplateList
            className='templates__icon'
            width='20'
            height='20'
            aria-hidden='true'
            focusable='false'
          />
        }
        text='Templates'
        className={classes.newBubble}
        style={{
          textTransform: 'none',
          color: 'unset',
        }}
      />
      <Menu
        style={{ zIndex: 999999 }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}>
        {applyTemplateMenuItems}
        <TemplatesMenuItem disabled>Actions</TemplatesMenuItem>
        {hasTemplates && !isMobileDevice ? (
          <TemplatesMenuItem onClick={openManageTemplatesModal}>
            Manage templates
          </TemplatesMenuItem>
        ) : null}
        <TemplatesMenuItem
          onClick={() => {
            handleClose();
            window.open(
              'https://intercom.help/venuescannercom/en/articles/6448958-inbox-templates',
              '_blank',
            );
          }}>
          Learn more
        </TemplatesMenuItem>
      </Menu>
    </>
  );
};

export default TemplatesPopupMenu;
